import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChangelogEntryCard from './ChangelogEntryCard';
import styles from './Changelog.module.css';

/**
 * Uma semana de novidades: destaques primeiro, depois as demais entradas e, por último,
 * as correções recolhidas em "N correções nesta semana".
 *
 * Props:
 *   week          - { id, label, highlights, entries, fixes } (groupByWeek)
 *   expandFixes   - abre as correções (quando o filtro é "Correções")
 *   cardProps     - (entry) => props extras do cartão (showPlan, onPlanClick, onOpenScreen)
 */
const ChangelogWeek = ({ week, expandFixes = false, cardProps }) => {
  const [fixesOpen, setFixesOpen] = useState(false);
  const showFixes = expandFixes || fixesOpen;
  const fixCount = week.fixes.length;

  return (
    <section className={styles.week} id={week.id}>
      <h2 className={styles.weekTitle}>{week.label}</h2>

      {week.highlights.map((entry) => (
        <ChangelogEntryCard key={entry.id} entry={entry} highlight {...cardProps(entry)} />
      ))}

      {week.entries.length > 0 && (
        <div className={styles.entryGrid}>
          {week.entries.map((entry) => (
            <ChangelogEntryCard key={entry.id} entry={entry} {...cardProps(entry)} />
          ))}
        </div>
      )}

      {fixCount > 0 && !expandFixes && (
        <button
          type="button"
          className={styles.fixesToggle}
          onClick={() => setFixesOpen((open) => !open)}
          aria-expanded={fixesOpen}
        >
          {fixCount === 1 ? '1 correção nesta semana' : `${fixCount} correções nesta semana`}
          <ExpandMoreIcon sx={{ fontSize: 18, transform: fixesOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }} />
        </button>
      )}

      {fixCount > 0 && showFixes && (
        <div className={styles.entryGrid}>
          {week.fixes.map((entry) => (
            <ChangelogEntryCard key={entry.id} entry={entry} {...cardProps(entry)} />
          ))}
        </div>
      )}
    </section>
  );
};

export default ChangelogWeek;
